export const APP_TITLE = 'WebGPU Art Playground';
export const CLEAR_COLOR: GPUColorDict = { r: 0.02, g: 0.02, b: 0.03, a: 1.0 };
export const MAX_CANVAS_DIM = 4096;
